module.exports = __webpack_public_path__ + "img/onroad.644561f3.jpg";